module.exports = __webpack_public_path__ + "assets/dish_type-c7b486.svg";